import { render, staticRenderFns } from "./UpdateCoverForm.vue?vue&type=template&id=25b28975"
import script from "./UpdateCoverForm.vue?vue&type=script&lang=js"
export * from "./UpdateCoverForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports